<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges"></alert-unsaved-changes>
    <v-form
      v-show="!loading && !resourceLoading"
      ref="form"
      v-model="valid"
      :lazy-validation="false"
    >
      <v-row>
        <v-col v-if="!next" cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('optional-info') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-10">
                <v-row>
                  <v-col v-if="!next" cols="6">
                    <label>{{ $t('user-manual') }}</label>
                    <p class="label-info">
                      {{ $t('Upload pdf') }}
                    </p>
                    <v-file-input
                      v-model="addUserManual"
                      :disabled="!edit"
                      outlined
                      :placeholder="'Upload pdf'"
                      clearable
                      prepend-icon=""
                    >
                    </v-file-input>
                    <div v-if="userManualFile">
                      <v-chip :disabled="!edit" :close="true" @click:close="deleteUserManual">
                        {{ userManualFile }}
                      </v-chip>
                    </div>
                    <div align="center">
                      <v-btn
                        @click="uploadUserManual"
                        :disabled="!isUserManualFileSelected"
                        depressed
                        rounded
                        medium
                        color="primary200"
                        class="white--text font-weight-bold"
                        >Upload File
                        <v-icon color="white">mdi-upload</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <label>{{ $t('terms-of-use') }}</label>
                    <p class="label-info">
                      {{ $t('Upload pdf') }}
                    </p>
                    <v-file-input
                      v-model="addTermsOfUse"
                      :disabled="!edit"
                      outlined
                      :placeholder="'Upload pdf'"
                      clearable
                      prepend-icon=""
                    >
                    </v-file-input>
                    <div v-if="termsOfUseFile">
                      <v-chip :disabled="!edit" :close="true" @click:close="deleteTermsOfUse">
                        {{ termsOfUseFile }}
                      </v-chip>
                    </div>
                    <div align="center">
                      <v-btn
                        @click="uploadTermsOfUse"
                        :disabled="!isTermsOfUseFileSelected"
                        depressed
                        rounded
                        medium
                        color="primary200"
                        class="white--text font-weight-bold"
                        >Upload File
                        <v-icon color="white">mdi-upload</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <label>Standards</label>
                    <p class="label-info">List of standards supported by the Service.</p>
                    <v-combobox
                      v-model="standards"
                      :disabled="!edit"
                      clearable
                      :placeholder="'Standards'"
                      multiple
                      small-chips
                      return-object
                      outlined
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Type and press <span class="text-bold">enter</span> to create a new
                              standard
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ attrs, item, parent, selected }">
                        <v-chip
                          v-bind="attrs"
                          :disabled="!edit"
                          :input-value="selected"
                          :close="true"
                          @click:close="removeChip(item)"
                        >
                          <span class="pr-2">
                            {{ item }}
                          </span>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!--BUTTONS-->
      <v-row class="my-5" v-if="!next && edit" justify="end">
        <v-btn outlined class="black--text font-weight-bold mx-2" rounded x-large @click="cancel()">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          depressed
          rounded
          x-large
          color="primary200"
          class="white--text font-weight-bold"
          @click="add()"
          :disabled="!valid"
          >{{ $t('update') }}
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'ResourceAdditionalInfo',
  mixins: [util],
  components: {
    AlertUnsavedChanges,
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valid: false,
      loadingComponents: -1,
      unsavedChanges: false,
      addUserManual: null,
      isUserManualFileSelected: false,
      userManualFile: null,
      addTermsOfUse: null,
      isTermsOfUseFileSelected: false,
      termsOfUseFile: null,
      resourceLoading: true,
      standards: [],
      initialStandards: {},
    };
  },
  mounted() {
    this.loadingComponents++;
  },
  watch: {
    loading(value) {
      if (value === false) {
        console.log('Loading');
        if (this.id != null) {
          this.axios
            .get('/api/v1/resources/' + this.id)
            .then(res => {
              this.userManualFile = res.data.userManual;
              this.termsOfUseFile = res.data.termsOfUse;
              this.standards = res.data.standards;

              this.initialStandards = JSON.parse(JSON.stringify(this.standards));
              this.$nextTick(() => {
                this.resourceLoading = false;
              });
            })
            .catch(error => {
              console.log({ error });
            });
        } else {
          this.resourceLoading = false;
        }
      }
    },
    addUserManual(newVal) {
      this.isUserManualFileSelected = newVal !== null;
    },
    addTermsOfUse(newVal) {
      this.isTermsOfUseFileSelected = newVal !== null;
    },
    standards: {
      deep: true,
      handler(newStandard) {
        if (JSON.stringify(newStandard) !== JSON.stringify(this.initialStandards)) {
          this.unsavedChanges = true;
        } else {
          this.unsavedChanges = false;
        }
      },
    },
  },
  computed: {
    loading() {
      return this.loadingComponents !== 0;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel', true);
      this.unsavedChanges = false;
    },
    uploadUserManual() {
      const id = this.id;

      if (this.addUserManual) {
        const fileType = this.addUserManual.type;
        if (fileType !== 'application/pdf') {
          EventBus.$emit('snackbar', {
            text: 'Only PDF files are allowed!',
          });
          return;
        }

        const formData = new FormData();
        formData.append('type', this.addUserManual.type);
        formData.append('name', this.addUserManual.name);
        formData.append('size', this.addUserManual.size);
        formData.append('file', this.addUserManual);

        this.axios
          .put(`api/v1/resources/${id}/file?field=userManual`, formData)
          .then(response => {
            console.log('Response Add File:', response.data);
            EventBus.$emit('snackbar', {
              text: 'File uploaded successfully!',
            });
            this.axios.get('/api/v1/resources/' + this.id).then(res => {
              this.userManualFile = res.data.userManual;
              this.$nextTick(() => {
                this.resourceLoading = false;
              });
            });
            this.addUserManual = null;
            this.unsavedChanges = false;
            this.$emit('cancel', true);
          })
          .catch(error => {
            console.log('Error:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to upload file. Please try again.',
            });
          });
      } else {
        console.log('Invalid file or id');
      }
    },
    deleteUserManual() {
      const id = this.id;

      if (this.userManualFile) {
        const fileName = this.userManualFile.name;

        this.axios
          .put(`api/v1/resources/${id}/file/${fileName}?field=userManual`)
          .then(response => {
            console.log('User manual deleted successfully:', response.data);
            EventBus.$emit('snackbar', {
              text: 'User manual Deleted successfully!',
            });
            this.userManualFile = null;
            this.addUserManual = null;
            this.unsavedChanges = false;
            this.$emit('cancel', true);
          })
          .catch(error => {
            console.error('Error deleting user manual:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to delete user manual. Please try again.',
            });
          });
      } else {
        console.log('No user manual file to delete.');
      }
    },
    uploadTermsOfUse() {
      const id = this.id;

      if (this.addTermsOfUse) {
        const fileType = this.addTermsOfUse.type;
        if (fileType !== 'application/pdf') {
          EventBus.$emit('snackbar', {
            text: 'Only PDF files are allowed!',
          });
          return;
        }

        const formData = new FormData();
        formData.append('type', this.addTermsOfUse.type);
        formData.append('name', this.addTermsOfUse.name);
        formData.append('size', this.addTermsOfUse.size);
        formData.append('file', this.addTermsOfUse);

        this.axios
          .put(`api/v1/resources/${id}/file?field=termsOfUse`, formData)
          .then(response => {
            console.log('Response Add File:', response.data);
            EventBus.$emit('snackbar', {
              text: 'File uploaded successfully!',
            });
            this.axios.get('/api/v1/resources/' + this.id).then(res => {
              this.termsOfUseFile = res.data.termsOfUse;
              this.$nextTick(() => {
                this.resourceLoading = false;
              });
            });
            this.addTermsOfUse = null;
            this.unsavedChanges = false;
            this.$emit('cancel', true);
          })
          .catch(error => {
            console.log('Error:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to upload file. Please try again.',
            });
          });
      } else {
        console.log('Invalid file or id');
      }
    },
    deleteTermsOfUse() {
      const id = this.id;

      if (this.termsOfUseFile) {
        const fileName = this.termsOfUseFile.name;

        this.axios
          .put(`api/v1/resources/${id}/file/${fileName}?field=termsOfUse`)
          .then(response => {
            console.log('Terms of Use deleted successfully:', response.data);
            EventBus.$emit('snackbar', {
              text: 'Terms of Use Deleted successfully!',
            });
            this.termsOfUseFile = null;
            this.addTermsOfUse = null;
            this.unsavedChanges = false;
            this.$emit('cancel', true);
          })
          .catch(error => {
            console.error('Error deleting terms of use:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to delete terms of use. Please try again.',
            });
          });
      } else {
        console.log('No terms of use file to delete.');
      }
    },
    add() {
      EventBus.$emit('waiting', true);

      const standards = this.standards.map(standard => standard);
      const serviceStandards = {
        id: this.id,
        standards: standards,
      };

      this.axios
        .post('/api/v1/resources/additional-info', serviceStandards)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('resource-updated'),
          });
          this.unsavedChanges = false;
          this.$emit('cancel', true);
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeChip(itemText) {
      this.standards.forEach(obj => {
        if (obj === itemText) {
          this.standards.splice(this.standards.indexOf(obj), 1);
        }
      });
      this.standards = [...this.standards];
    },
  },
};
</script>
